"use client";

import { useTranslation } from "react-i18next";
import { Wallet, TrendingUp } from "lucide-react";

function formatCurrency(value: number): string {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export type ExceededCreditsCardModalUsedValuesProps = {
  excessValue: number;
  excessPercentage: number;
};

export function ExceededCreditsCardModalUsedValues({
  excessValue,
  excessPercentage,
}: ExceededCreditsCardModalUsedValuesProps) {
  const { t } = useTranslation(["dashboard"]);

  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="rounded-lg bg-white shadow-lg shadow-[#854d0e08]">
        <div className="border-b border-lightgray-400 p-3">
          <span className="text-sm font-normal text-darkgray-900">
            {t(
              "exceeded-credits-modal-excess-spending",
              "Gasto excedente em R$",
            )}
          </span>
        </div>

        <div className="flex flex-col items-center gap-4 py-6">
          <Wallet className="h-4 w-4 text-danger-500" />
          <div className="flex flex-col items-center gap-1">
            <span className="text-xl font-medium text-graydark-900">
              {formatCurrency(excessValue)}
            </span>
            <p className="text-xs text-muted-foreground">
              {t(
                "exceeded-credits-modal-excess-spending-desc",
                "a mais em X meses por excedente",
              )}
            </p>
          </div>
        </div>
      </div>

      <div className="rounded-lg bg-white shadow-lg shadow-[#854d0e08]">
        <div className="border-b border-lightgray-400 p-3">
          <span className="text-sm font-normal text-darkgray-900">
            {t(
              "exceeded-credits-modal-excess-percent",
              "Créditos excedentes em %",
            )}
          </span>
        </div>
        <div className="flex flex-col items-center gap-4 py-6">
          <TrendingUp className="h-4 w-4 text-danger-500" />
          <div className="flex flex-col items-center gap-1">
            <span className="text-xl font-medium text-graydark-900">
              {excessPercentage}%
            </span>
            <p className="text-xs text-muted-foreground">
              {t(
                "exceeded-credits-modal-excess-percent-desc",
                "do consumo total foi excedente",
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
